<template>
    <div class="tab-portal">
        <img class="img" :src="templateImage" alt="">
        <div class="tombstone-wrap">
            <div class="img-wrap">
                <img :src="headImage"  alt="" class="header-img">
            </div>
            <div class="name" v-if="info.deadNums == 1">{{ info.deadName }}</div>
            <div class="names" v-else>
                <div class="name" v-for="(item, index) in info.deadNames" :key="index">{{ item }}</div>
            </div>
            <div class="name">之墓</div>
        </div>
        <div class="synopsis-wrap">
            <div class="synopsis-content">
                <div class="title">— 生平简介 —</div>
                <div ref="descWrap" class="desc-wrap">
                    <div class="desc" v-html="info.life"></div>
                </div>
                <div class="show-more" @click="showMoreBrief">更多——></div>
            </div>
            <div class="operation-wrap">
                <div class="operation-item" @click="selectOperationItem(index,item)" v-for="(item,index) in operationList" :key="index">
                    <i class="icon" :class="item.key"></i>
                    <div>{{item.name}}</div>
                </div>
            </div>
        </div>
        <send-modal :type="sendModalType" @closeModal="closeModal('send')" @submitSuccess="closeModal('send')" :fade="plugin.modal.send.fade"></send-modal>
    </div>
</template>

<script>
    let self
    import sendModal from './sendModal'
    import util from '../../../utils/util'
    export default {
        name: 'portal',
        props:{
            info :{
                type:Object,
                default(){
                    return {}
                }
            }
        },
        components: {
            sendModal
        },
        watch:{
            'info.templateId'(id){
                this.templateImage = require(`../../../assets/images/gif/${id}.gif`)
            },
            'info.headImage'(src){
                this.headImage = src.replace('website.seabury.sfitech','website.seabury.dev.sfitech')
                console.log('watchHeadImgafter----',this.headImage)
                // util.getImgSize(this.headImage,function (w,h) {
                //     // console.log('w----',w)
                //     // console.log('h----',h)
                //     util.parseImgStyle(w,h,self,'headImgStyle')
                // })
            }
        },
        computed:{
            deadName(){
                let name = this.info.deadName;
                let nameArr = [];
                if(name && name.indexOf(',')>-1){
                    nameArr = name.split(',')
                }else if(name && name.indexOf('，')>-1){
                    nameArr = name.split('，')
                }
                if(nameArr.length>1){
                    name = nameArr.join('')
                }
                return name
            }
        },
        data(){
            return{
                imgList:[],
                headImage:'',
                // headImgStyle:{
                //     width:'100%',
                //     height:'100%'
                // },
                templateImage:'',
                currentOperationIndex:0,
                sendModalType:'',
                operationList:[{
                    key:'flower',
                    name:'献花',
                },{
                    key:'music',
                    name:'点歌',
                },{
                    key:'wine',
                    name:'祭酒',
                }],
                plugin:{
                    modal:{
                        send:{
                            fade:false
                        }
                    }
                },
            }
        },
        mounted(){
            self = this;
            this.addEventDescWrapScroll()
        },
        methods:{
            showMoreBrief(){
                this.$emit('showMoreBrief')
            },
            addEventDescWrapScroll(){
                var area = this.$refs.descWrap
                var everyH = 20;
                var speed =30;
                var scrollTopIng = false;
                var time;
                var time1;
                var delay = 30;
                area.scrollTop = 0;
                // console.log('area.height',area.clientHeight)
                // console.log('area.scrollHeight',area.scrollHeight)
                function startScroll(){
                    time=setInterval(scrollUp,speed);
                    area.scrollTop++;
                }
                function scrollToTop() {
                    clearInterval(time1)
                    clearInterval(time)
                    time1 =  setInterval(function () {
                        if(area.scrollTop>0){
                            scrollTopIng = true;
                            area.scrollTop-=50;
                        }else{
                            // console.log('返回向上停止')
                            scrollTopIng = false;
                            clearInterval(time1)
                            startScroll()
                        }
                    },30)
                }
                function scrollUp(){
                    if(area.scrollTop % everyH==0 && !scrollTopIng){
                        clearInterval(time);
                        setTimeout(startScroll,delay);
                    }else{
                        if(scrollTopIng)return
                        area.scrollTop++;
                        if(area.scrollTop >= area.scrollHeight-area.clientHeight){
                            clearInterval(time)
                            if(area.scrollHeight>300){
                                scrollToTop()
                            }else{
                                area.scrollTop = 0
                            }
                        }
                    }
                }
                startScroll()
            },
            selectOperationItem(index,item){
                this.currentOperationIndex = index;
                this.sendModalType = item.key
                this.plugin.modal.send.fade = true;
            },
            closeModal(key){
                this.plugin.modal[key].fade=false
            },
        }
    }
</script>

<style scoped lang="scss">
    .tab-portal{
        padding: 60px 50px;
        position: relative;
        .img{
            width: 100%;
        }
        .tombstone-wrap{
            position: absolute;
            top: 300px;
            left: 570px;
            .img-wrap{
                height: 90px;
                width: 70px;
                overflow: hidden;
                .header-img{
                    max-height: 100%;
                    max-width: 100%;
                    position: relative;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50% ,-50%);
                }
            }

            .names {
                display: flex;
            }

            .name{
                width: 20px;
                padding-top: 10px;
                margin: 0 auto;
                font-family: cursive;
                font-size: 14px;
                font-weight: 600;
                color: #010101;
            }
        }
        .synopsis-wrap{
            position: absolute;
            overflow: hidden;
            top: 140px;
            right: 80px;
            background-color: #fff;
            width: 240px;
            height: 340px;
            .synopsis-content{
                font-size: 14px;
                padding: 15px 18px;
                .title{
                    font-size: 20px;
                    padding-bottom: 10px;
                }
                .desc-wrap{
                    height: 170px;
                    overflow-x: hidden;
                    overflow-y: scroll;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .desc{
                        line-height: 30px;
                    }
                }
                .show-more{
                    color: #009DE9;
                    margin-top: 10px;
                    text-align: right;
                    &:hover{
                        cursor: pointer;
                        color:#0c7fb7;
                    }
                }
            }
            .operation-wrap{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                background-color: #009DE9;
                overflow: hidden;
                color: #fff;
                .operation-item{
                    margin: 10px 0;
                    float: left;
                    width: 33%;
                    height: 48px;
                    border-right: 1px solid #fff;
                    &:last-child{
                        border-right: none;
                    }
                    .icon{
                        width: 30px;
                        height: 30px;
                        text-align: center;
                        display: inline-block;
                        background-size: contain;
                        &.flower{
                            background-image: url('../../../assets/images/icon/flower.png');
                        }
                        &.music{
                            background-image: url('../../../assets/images/icon/music.png') ;
                        }
                        &.wine{
                            background-image: url('../../../assets/images/icon/wine.png') ;
                        }
                    }
                    &:hover{
                        cursor: pointer;
                        box-shadow: 2px 2px 2px rgba(0,0,0,0.1);
                    }
                }
            }
        }
    }
</style>
